<template lang="pug">
erp-view(
  id="RolesSeguridadTab"
  ref="RolesSeguridadTab"
  title="Roles Seguridad"
  :blank="true"
  :hide-header-title="true"
  hide-header-action=true
)
  // ───────── CONTENIDO ─────────
  template(slot="content")
    .form-container
      // === ENCABEZADO: USUARIO ===
      .section
        .section-title.centered
          span.usuario-nombre-badge
            i.fas.fa-user-lock
            | Usuario : {{ modelo.nombreCompleto || 'Sin nombre' }}

      // === SECCIÓN DE ROLES SEGURIDAD ===
      .section
        .section-header
          .section-icon 🔒
          .section-title Roles del Esquema SEGURIDAD
        .section-body
          .ed-grid.s-grid-1.m-grid-3.rows-gap.gap-1

            // ---- CLONADOS ----
            .s-cols-1.m-cols-1
              .card.card-dark
                .card-title
                  i.fas.fa-clone
                  | Roles Clonados ({{ rolesClonados.length }})

                div.list-actions
                  a.btn-select-all(@click="seleccionarTodosClonados") 
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosClonados") 
                    i.fa.fa-square.mr-1
                    | Quitar selección

                dx-list(
                  :data-source="rolesClonados"
                  display-expr="nombre"
                  selection-mode="multiple"
                  :show-selection-controls="true"
                  :selected-item-keys.sync="seleccionadosClonados"
                  :search-enabled="true" 
                  :search-expr="'nombre'"
                  :item-template="itemTemplateRol"
                  height="250"
                )
                .card-actions
                  dx-button(
                    text="Aplicar a Asignados"
                    type="normal"
                    icon="fa fa-arrow-right"
                    @click="moverSeleccionadosClonadosAAsignados"
                  )

            // ---- ASIGNADOS ----
            .s-cols-1.m-cols-1
              .card.card-green
                .card-title
                  i.fas.fa-check-circle
                  | Roles Asignados ({{ rolesAsignados.length }})

                div.list-actions
                  a.btn-select-all(@click="seleccionarTodosAsignados") 
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosAsignados") 
                    i.fa.fa-square.mr-1
                    | Quitar selección
                dx-list(
                  :data-source="rolesAsignados"
                  display-expr="nombre"
                  selection-mode="multiple"
                  :show-selection-controls="true"
                  :selected-item-keys.sync="seleccionadosAsignados"
                  :search-enabled="true" 
                  :search-expr="'nombre'"
                  :item-template="itemTemplateRol"
                  height="250"
                )
                .card-actions
                  dx-button(
                    text="Quitar Roles Seleccionados"
                    type="danger"
                    icon="fa fa-trash"
                    @click="quitarSeleccionadosDeAsignados"
                  )

            // ---- NO ASIGNADOS ----
            .s-cols-1.m-cols-1
              .card.card-red
                .card-title
                  i.fas.fa-times-circle
                  | Roles No Asignados ({{ rolesDisponibles.length }})
                
                div.list-actions
                  a.btn-select-all(@click="seleccionarTodosDisponibles") 
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosDisponibles") 
                    i.fa.fa-square.mr-1
                    | Quitar selección
                dx-list(
                  :data-source="rolesDisponibles"
                  display-expr="nombre" 
                  selection-mode="multiple"
                  :show-selection-controls="true"
                  :selected-item-keys.sync="seleccionadosDisponibles"
                  :search-enabled="true" 
                  :search-expr="'nombre'"
                  :item-template="itemTemplateRol"
                  height="250"
                )
                .card-actions
                  dx-button(
                    text="Asignar al Usuario"
                    type="success"
                    icon="fa fa-arrow-left"
                    @click="moverSeleccionadosDisponiblesAAsignados"
                  )

      // === SECCIÓN ÁRBOL JERÁRQUICO ===
      .section.mt-2
        .section-header
          .section-icon 🌳
          .section-title Mapa Jerárquico de Roles Asignados
        .section-body
          dx-tree-view(
            ref="treeJerarquiaSeg"
            :items="rolesAsignadosTree"
            key-expr="id"
            display-expr="nombre"
            data-structure="tree"
            selection-mode="none"
            show-check-boxes-mode="none"
            :search-enabled="true"
            search-mode="contains"
            height="350"
          )

      // === SECCIÓN DE MÓDULOS HABILITADOS ===
      .section.mt-2
        .section-header
          .section-icon 🧩
          .section-title Módulos Habilitados por Roles Asignados
        .section-body
          dx-data-grid(
            :data-source="rolesSeguridadModulos"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="true"
            row-alternation-enabled
            :column-auto-width="true"
            height="400"
            :grouping="{ autoExpandAll: false }"
            :group-panel="{ visible: true }"
            :filter-row="{ visible: true }"
            :header-filter="{ visible: true }"
          ) 
             
            dx-export(:enabled="true" file-name="ModulosPorRoles")
            dx-scrolling(mode="virtual")
            
            dx-column(data-field="rolPrincipal" caption="Rol Principal"   width="180")
            dx-column(data-field="rolSecundario" caption="Rol Secundario" width="180")
            dx-column(data-field="modulo" caption="Módulo Habilitado" width="200")
            dx-column(data-field="rutaRol" caption="Ruta Jerárquica" width="400")

      // === SECCIÓN DE MÓDULOS HABILITADOS ===
      .section.mt-2
        .section-header
          .section-icon 🧩
          .section-title Permisos Habilitados por Roles Asignados
        .section-body
          dx-data-grid(
            :data-source="rolesSeguridadPermisos"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="true"
            row-alternation-enabled
            :column-auto-width="true"
            height="88%"
            :grouping="{ autoExpandAll: false }"
            :group-panel="{ visible: true }"
            :filter-row="{ visible: true }"
            :header-filter="{ visible: true }"
          )

            dx-export(:enabled="true" file-name="PermisosPorRoles")
            dx-scrolling(mode="virtual")

            dx-column(data-field="rolPrincipal" caption="Rol Principal"  width="180")
            dx-column(data-field="rolSecundario" caption="Rol Secundario" width="180")
            dx-column(data-field="accion" caption="Permiso (Accion)" width="200")
            dx-column(data-field="entidad" caption="Permiso (Entidad)" width="200")
            dx-column(data-field="regla" caption="Permiso (Regla)" width="200")
            dx-column(data-field="permisoConcatenado" caption="Permiso Concatenado" width="200")
            dx-column(data-field="rutaRol" caption="Ruta Jerárquica" width="400")

      .section.mt-2
        .section-header
        .section-body
</template>

<script>

import controlUsuarioResource from "@/api/ControlUsuarioResource.js";

export default {
  name: "RolesSeguridadTab",
  props: {
    modelo: { type: Object, required: true },
    listas: { type: Object, required: true }
  },
  data() {
    return {
      rolesClonados: [],
      rolesAsignados: [],
      rolesDisponibles: [],
      rolesSeguridadModulos: [],
      rolesSeguridadPermisos: [],
      // Árbol visual
      rolesAsignadosTree: [],

      // Selecciones
      seleccionadosClonados: [],
      seleccionadosAsignados: [],
      seleccionadosDisponibles: []
    };
  },

  watch: {
    listas: {
      handler(nuevasListas) {
        if (!nuevasListas) return;
        this.rolesClonados   = nuevasListas.rolesSeguridadClonados   || [];
        this.rolesAsignados  = nuevasListas.rolesSeguridadAsignados  || [];
        this.rolesDisponibles = nuevasListas.rolesSeguridadDisponibles || [];
        this.rolesSeguridadModulos = nuevasListas.rolesSeguridadModulos || [];
        this.rolesSeguridadPermisos = nuevasListas.rolesSeguridadPermisos || [];
        
        this.regenerarJerarquia();
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
     
    seleccionarTodosAsignados() {
      this.seleccionadosAsignados = this.rolesAsignados;
    },

    deseleccionarTodosAsignados() {
      this.seleccionadosAsignados = [];
    },  
    seleccionarTodosDisponibles() {
      this.seleccionadosDisponibles = this.rolesDisponibles;
    }, 
    deseleccionarTodosDisponibles() {
      this.seleccionadosDisponibles = [];
    },
    seleccionarTodosClonados() { 
      this.seleccionadosClonados = this.rolesClonados;
    },

    deseleccionarTodosClonados() {
      this.seleccionadosClonados = [];
    },  

    itemTemplateRol(itemData) {
      const ruta = itemData.rutaBusqueda || itemData.RutaBusqueda || "Sin ruta";
      const div = document.createElement("div");
      div.textContent = itemData.nombre;
      div.title = ruta;
      div.className = "item-rol-tooltip";
      return div;
    },

    // === Construir árbol jerárquico de asignados ===
    buildRoleTree(items) {
      const root = [];
      if (!Array.isArray(items) || items.length === 0) return root;

      items.forEach((r, index) => {
        const ruta = r.rutaBusqueda || r.RutaBusqueda;
        if (!ruta || typeof ruta !== "string" || ruta.trim() === "") return;

        const parts = ruta.split("/").filter(Boolean);
        let currentLevel = root;

        parts.forEach((segment, i) => {
          let existing = currentLevel.find(x => x.nombre.startsWith(segment));

          if (!existing) {
            existing = {
              id: `${r.id}-${i}-${index}`,
              nombre: segment,
              expanded: i < 2,
              items: []
            };
            currentLevel.push(existing);
          }

          // ✅ Si es el último nivel (el rol asignado), agrega el ícono si aún no lo tiene
          if (i === parts.length - 1 && !existing.nombre.includes("✅")) {
            existing.nombre += " ✅";
          }

          currentLevel = existing.items;
        });
      });
      return root;
    },


    regenerarJerarquia() { 
      
      console.log("2 Objetos modulos ():", this.rolesSeguridadModulos ); // eslint-disable-line  
      this.rolesAsignadosTree = this.buildRoleTree(this.rolesAsignados); 
    },
    AsignarRolesSeguridad(rolesSeguridad,UsuarioId) { 
      
      controlUsuarioResource
        .asignarRolesSeguridad(rolesSeguridad,UsuarioId)
        .then(() => { 
          //Object.assign(this.modelo, res.data);  
          this.$emit("roles-seguridad-actualizados", this.modelo.id, this.modelo.usuarioClonarId);
          this.$msg.success("Ejecucion Terminada"); 
        })
        .catch(err => { 
          this.$msg.handleError(err, "Asinar roles Seguridad");
        });

    },
    RetirarRolesSeguridad(rolesSeguridad,UsuarioId) { 
      
      controlUsuarioResource
        .retirarRolesSeguridad(rolesSeguridad,UsuarioId)
        .then(() => { 
          //Object.assign(this.modelo, res.data);  
          this.$emit("roles-seguridad-actualizados", this.modelo.id, this.modelo.usuarioClonarId);
          this.$msg.success("Ejecucion Terminada"); 
        })
        .catch(err => { 
          this.$msg.handleError(err, "Retirar roles Seguridad");
        });

    },

    // === ACCIONES ===
    moverSeleccionadosClonadosAAsignados() {
      if (!this.seleccionadosClonados.length)
        return this.$msg?.error?.("Seleccione al menos un rol clonado.");
 
      this.AsignarRolesSeguridad(this.seleccionadosClonados,this.modelo.id) 
      this.seleccionadosClonados = [];
      this.regenerarJerarquia(); 
    },

    quitarSeleccionadosDeAsignados() {
      if (!this.seleccionadosAsignados.length)
        return this.$msg?.error?.("Seleccione al menos un rol asignado.");

      
      this.RetirarRolesSeguridad(this.seleccionadosAsignados,this.modelo.id)
      this.seleccionadosAsignados = [];
      this.regenerarJerarquia(); 
    },

    moverSeleccionadosDisponiblesAAsignados() {
      if (!this.seleccionadosDisponibles.length)
        return this.$msg?.error?.("Seleccione al menos un rol disponible.");

      
      this.AsignarRolesSeguridad(this.seleccionadosDisponibles,this.modelo.id) 
 
      this.seleccionadosDisponibles = [];
      this.regenerarJerarquia(); 
    }
  }
};
</script>

<style scoped>

.list-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 6px;
}

.list-actions a {
  cursor: pointer;
  font-size: 0.85rem;
  color: #2563eb;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.list-actions a:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

/* ======= ESTRUCTURA GENERAL ======= */
.section-title.centered {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 8px;
  margin-bottom: 10px;
}
.form-container {
  background: #f8fafc;
  padding: 10px 12px;
  border-radius: 10px;
  max-width: 960px;
  margin: 0 auto;
}
.section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  margin-bottom: 5px;
  padding: 10px 15px;
}
.section.subtle {
  background: #f4faff;
  border-left: 3px solid #4ea1ff;
}
.section-header { display: flex; align-items: center; margin-bottom: 6px; }
.section-icon { font-size: 18px; margin-right: 6px; }
.section-title { font-weight: 500; font-size: 14px; color: #005b99; }
/* ======= ETIQUETA USUARIO ======= */
.usuario-nombre-badge {
  display: inline-flex;
  align-items: center !important;
  gap: 6px;
  font-weight: 800;
  background: #e0f2fe;
  color: #0369a1;
  border: 1px solid #7dd3fc;
  padding: 2px 14px;
  border-radius: 20px;
  margin-left: 8px;
  font-size: 18px;
}
.usuario-nombre-badge i {
  color: #4acb1f;
}

/* ======= TARJETAS ======= */
.card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  padding: 10px;
  min-height: 220px;
}
.card-title {
  font-weight: 600;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
}
.card-actions {
  display: flex;
  gap: 6px;
  margin-top: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
.card-dark { border-color: #111827; }
.card-green { border-color: #10b981; }
.card-red { border-color: #ef4444; }

/* ======= TREE VIEW ======= */
:deep(.dx-treeview-item-content) {
  font-size: 14px;
}

/* ======= TOOLTIP ITEMS ======= */
.item-rol-tooltip {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: help;
}
</style>
